/**
 * Create React App entry point. This and `public/index.html` files can not be
 * changed or moved.
 */
import "react-app-polyfill/ie11"
import "react-app-polyfill/stable"
import React from "react"
import ReactDOM from "react-dom"
import axios from "axios"
import * as _redux from "./redux"
import store, { persistor } from "./redux/store"
import App from "./app/App"
import * as serviceWorker from "./serviceWorker"

import "./index.scss" // Standard version
// import "./sass/style.react.rtl.css"; // RTL version
import "./_metronic/_assets/plugins/keenthemes-icons/font/ki.css"
import "socicon/css/socicon.css"
import "@fortawesome/fontawesome-free/css/all.min.css"
import "./_metronic/_assets/plugins/flaticon/flaticon.css"
import "./_metronic/_assets/plugins/flaticon2/flaticon.css"
// Datepicker
import "react-datepicker/dist/react-datepicker.css"
import {
  MetronicLayoutProvider,
  MetronicSplashScreenProvider,
  MetronicSubheaderProvider
} from "./_metronic/layout"
// import { MetronicI18nProvider } from "./_metronic/i18n";
import { SnackbarProvider } from "notistack"

const localstore = require("store")
/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const { PUBLIC_URL } = process.env

/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
/* const mock = */ _redux.mockAxios(axios)
/**
 * Inject metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
_redux.setupAxios(axios, store)

const path = window.location.href.replace(/^.+\?/i, "")
const searchParams = new URLSearchParams(path)
const shop = searchParams.get("shop")

// set diplay popup for sale code
localstore.set("popupshown", true)

// set shop params globally
if (shop && shop !== null) {
  localstore.set("shop", shop)
}

// iOS Modal Scrolling Fix
// Detect iOS devices
const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || /Macintosh/.test(navigator.userAgent) && 'ontouchend' in document

if (isIOS) {
  // Function to handle modal open/close
  const handleModalChange = (isOpen) => {
    if (isOpen) {
      document.body.classList.add('ant-modal-open')
      // Store current scroll position
      document.body.style.top = `-${window.scrollY}px`
    } else {
      document.body.classList.remove('ant-modal-open')
      // Restore scroll position
      const scrollY = document.body.style.top
      document.body.style.top = ''
      window.scrollTo(0, parseInt(scrollY || '0') * -1)
    }
  }

  // Monitor for modal changes
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.classList && node.classList.contains('ant-modal-root')) {
          handleModalChange(true)
        }
      })
      mutation.removedNodes.forEach((node) => {
        if (node.classList && node.classList.contains('ant-modal-root')) {
          handleModalChange(false)
        }
      })
    })
  })

  // Start observing the document body for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  })
}

ReactDOM.render(
  <MetronicLayoutProvider>
    <MetronicSubheaderProvider>
      <MetronicSplashScreenProvider>
        <SnackbarProvider maxSnack={3} style={{ fontSize: "14px" }}>
          <App store={store} persistor={persistor} basename={PUBLIC_URL} />
        </SnackbarProvider>
      </MetronicSplashScreenProvider>
    </MetronicSubheaderProvider>
  </MetronicLayoutProvider>,
  document.getElementById("root")
)
// serviceWorker.register();

// https://1217-2401-4900-1f3e-6a1f-69e7-299f-4c46-9e47.ngrok.io/?shop=myonlineteststoreforapp.myshopify.com&host=YWRtaW4uc2hvcGlmeS5jb20vc3RvcmUvbXlvbmxpbmV0ZXN0c3RvcmVmb3JhcHA&bypass=22868300104343534024
